import { Platform } from 'quasar'

const state = {
  pendingReportsCount: 0,
  pendingIssuesCount: 0,
  appRestartRequired: false,
  failedIssuesCount: 0
}

const getters = {
  pendingChangesCount: (state) =>
    state.pendingReportsCount + state.pendingIssuesCount,
  appRestartRequired: (state) => state.appRestartRequired,
  failedIssuesCount: (state) => state.failedIssuesCount,
  needInset: () => {
    return {
      android: Platform.is.android,
      all: Platform.is.ios || Platform.is.android
    }
  }
}

const actions = {
  setFailedIssuesCount({ commit }, count) {
    commit('SET_FAILED_ISSUES_COUNT', count)
  },
  setPendingReports({ commit }, count = 0) {
    commit('SET_PENDING_REPORTS_COUNT', count)
  },
  clearPendingReports({ commit }) {
    commit('SET_PENDING_REPORTS_COUNT', 0)
  },
  setPendingIssues({ commit }, count = 0) {
    commit('SET_PENDING_ISSUES_COUNT', count)
  },
  clearPendingIssues({ commit }) {
    commit('SET_PENDING_ISSUES_COUNT', 0)
  },
  setAppRequiresRestart({ commit }, isRequired) {
    commit('SET_APP_RESTART_REQUIRED', isRequired)
  },
  reset({ commit }) {
    commit('RESET')
  }
}

const mutations = {
  SET_PENDING_REPORTS_COUNT(state, payload) {
    state.pendingReportsCount = payload
  },
  SET_PENDING_ISSUES_COUNT(state, payload) {
    state.pendingIssuesCount = payload
  },
  SET_APP_RESTART_REQUIRED(state, payload) {
    state.appRestartRequired = payload
  },
  SET_FAILED_ISSUES_COUNT(state, next) {
    state.failedIssuesCount = next
  },
  RESET(state) {
    // NOTE: We don't reset the reporter email/password so that we can auto populate corresponding fields
    state.pendingReportsCount = 0
    state.pendingIssuesCount = 0
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
}
